export const SCRIPT_SRCS = {
  pingone: "https://assets.pingone.com/signals/web-sdk/5.0.1/signals-sdk.js",
  googleapis:
    "https://maps.googleapis.com/maps/api/js?key=AIzaSyBHMCnE5l_yQ3hUNs5YCsxk-V8fxO2HFeA&language=EN&libraries=places",
  iubenda: "https://cdn.iubenda.com/iubenda.js",
};
